export function setHtmlLang(lang = 'de') {
	document.getElementsByTagName('html')[0].setAttribute('lang', (lang === 'en-us' ? 'en' : 'de'));
}

export function constructActiveRouteUrl(url = '/') {
	return `https://www.bandara.ch${url}`;
}

export function transformHeadTitle(data) {
	return {
		inner: data.inner,
		complement: ' '
	}
}

export function transformHeadMeta(data) {
	return [
		{ n: 'description', c: data.metaDescription, id: 'desc' },
		{ p: 'og:title', c: data.ogTitle, id: 'ogtitle' },
		{ p: 'og:type', c: data.ogType, id: 'ogtype' },
		{ p: 'og:image', c: data.ogImage, id: 'ogimage' },
		{ p: 'og:url', c: data.ogUrl, id: 'ogurl' },
		{ p: 'og:description', c: data.ogDescription, id: 'ogdescription' },
		// { p: 'og:locale', c: data.ogLocale, id: 'oglocale' },
		// { p: 'og:locale:alternate', c: data.ogLocaleAlternate, id: 'oglocalealternate' },
		// { p: 'fb:admins', c: data.og_facebook_admins },
		{ n: 'twitter:card', c: 'summary', id: 'tc-summary' },
		{ n: 'twitter:site', c: data.site_twitter_handle, id: 'tc-site' },
		{ n: 'twitter:title', c: data.ogTitle, id: 'tc-title' },
		{ n: 'twitter:description', c: data.ogDescription, id: 'tc-desc' },
		{ n: 'twitter:image:src', c: data.ogImage, id: 'tc-img' },
		{ n: 'prerender-status-code', c: data.prerenderStatusCode },
		{ n: 'robots', c: data.robots }
	]
}

export function transformHeadLink(arg) {
	if (arg.i18n) {
		return [
			{ r: 'alternate', hreflang: 'en', h: arg.data['en-us'] },
			{ r: 'alternate', hreflang: 'de', h: arg.data['de-ch'] },
			{ r: 'canonical', href: arg.data.canonical }
		]
	} else {
		return [
			{ r: 'canonical', href: arg.data.canonical }
		]
	}
}

export function transformHeadData({ meta = {}, defaultMeta = {}, settings = {}, activeRouteUrl = {}, prerenderStatusCode = '200', robots = 'index, follow' }) {
	return {
		title: {
			inner: meta.pageTitle
		},
		meta: {
			metaDescription: meta.metaDescription ? meta.metaDescription : defaultMeta.default_meta_description,
			ogTitle: meta.ogTitle,
			ogType: meta.ogType,
			ogImage: meta.ogImage ? meta.ogImage : defaultMeta.default_og_image,
			ogUrl: activeRouteUrl,
			ogDescription: meta.ogDescription ? meta.ogDescription : defaultMeta.default_meta_description,
			ogLocale: (settings.currentLang === 'en-us' ? 'en_US' : 'de_DE'),
			ogLocaleAlternate: (settings.currentLang === 'en-us' ? 'de_DE' : 'en_US'),
			site_twitter_handle: defaultMeta.site_twitter_handle ? defaultMeta.site_twitter_handle : '',
			og_facebook_admins: defaultMeta.og_facebook_admins ? defaultMeta.og_facebook_admins : '',
			prerenderStatusCode: prerenderStatusCode,
			robots: robots
		},
		link: {
			'en-us': `https://www.bandara.ch${settings.altLangLinks['en-us']}`,
			'de-ch': `https://www.bandara.ch${settings.altLangLinks['de-ch']}`,
			canonical: activeRouteUrl,
			'publisher_google_plus_page': defaultMeta['publisher_google+_page'] ? defaultMeta['publisher_google+_page'] : ''
		}
	}
}

export function transformIsoDate(isostring) {
	let date = new Date(isostring);
	let year = date.getFullYear();
	let month = date.getMonth()+1;
	let day = date.getDate();
	if (day < 10) {
		day = '0' + day;
	}
	if (month < 10) {
		month = '0' + month;
	}
	return day + '.' + month + '.' + year;
}

export function transformWPDateFormat(string) {
	const regex = /([0-9]{4})-+([0-9]{2})-+([0-9]{2})(.{3}(\:.{2}){2})/g
	const str = string
	const subst = `$2.$3.$1`

	// The substituted value will be contained in the result variable
	const result = str.replace(regex, subst);

	return result
}



// WEBPACK FOOTER //
// ./src/utils/utils.js